import { createRouter, createWebHistory } from 'vue-router'

import { isAuthenticated } from '@/libs/auth'
import { useAppStore } from '@/stores/app'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    scrollBehavior() {
        return {
            top: 1,
            behavior: 'smooth'
        }
    },
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/uporabniki'
        },
        {
            path: '/uporabniki',
            name: 'users',
            component: () => import('@/views/Users/Users.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/uporabniki/:id/:code_payer',
            name: 'user',
            component: () => import('@/views/Users/User.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/partnerji',
            name: 'partners',
            component: () => import('@/views/Partners/Partners.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/vlozisca',
            name: 'depository',
            component: () => import('@/views/depository/Depositories.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/vlozisca/:depositoryId/vsebina',
            name: 'depository-documents',
            component: () => import('@/views/depository/DepositoryDocuments.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/oglasna-deska',
            name: 'bulletin-board',
            component: () => import('@/views/Bulletin/Bulletins.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/oglasna-deska/dodaj-oglas',
            name: 'add-bulletin',
            component: () => import('@/views/Bulletin/AddEditBulletin.vue'),
            meta: {
                requiresAuth: true
            }
        },

        {
            path: '/oglasna-deska/:id',
            name: 'edit-bulletin',
            component: () => import('@/views/Bulletin/AddEditBulletin.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pogosta-vprasanja',
            name: 'faq',
            component: () => import('@/views/Faq/Faqs.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/dovoljene-strani',
            name: 'allowed-pages',
            component: () => import('@/views/allowedPages/AllowedPages.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/spremeni-geslo',
            name: 'change-password',
            component: () => import('@/views/account/ChangePassword.vue'),
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/pozabljeno-geslo',
            name: 'forgotten-password',
            component: () => import('@/views/account/ForgottenPassword.vue'),
            meta: {
                layout: 'Blank',
                requiresAuth: false
            }
        },
        {
            path: '/pozabljeno-geslo/:token',
            name: 'reset-password',
            component: () => import('@/views/account/ResetPassword.vue'),
            meta: {
                layout: 'Blank',
                requiresAuth: false
            }
        },
        {
            path: '/prijava',
            name: 'login',
            component: () => import('@/views/account/Login.vue'),
            meta: {
                layout: 'Blank',
                requiresAuth: false
            }
        },
        {
            path: '/ni-najdeno',
            name: 'not-found',
            component: () => import('@/views/NotFound.vue'),
            meta: {
                layout: 'Blank',
                requiresAuth: false
            }
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/ni-najdeno'
        }
    ]
})

router.beforeEach((to, from, next) => {
    const loggedIn: boolean = isAuthenticated()
    const appStore = useAppStore()

    if (loggedIn && to.name === 'login') {
        next({ name: 'home' })
        return
    }

    if (to.meta.requiresAuth && !loggedIn) {
        appStore.setLogout()
        next({ name: 'login' })
    }

    next()
})

export default router
